<template>
  <div class="custom-group-tours-faq-contact-us">
    <div
      class="
        pa-16
        px-24
        sd-5
        br-12
        flex
        mb-flex-column
        items-center
        mb-items-start
        tl-items-center
        mb-justify-start
        justify-between
      "
    >
      <div class="flex mb-flex-column mb-wp-100 mb-mb-24">
        <div class="image w-80 h-80 br-p-50 overflow-hidden mr-24 mb-mb-24">
          <img
            class="w-80 h-80"
            :src="`${ASSETS_CDN}/images/customgrouptour/faq_contact.png`"
            alt="agent_picture"
          />
        </div>
        <div class="flex flex-column justify-center">
          <h3 class="fs-20 fw-700 lh-28 ls-1" v-html="title"></h3>
          <p class="fw-500 fs-16 lh-22 mb-0 gray-dark">{{ content }}</p>
        </div>
      </div>
      <CGTButtons
        color="yellow"
        sendMail
        :title="FAQ_CONTACT_CTA"
        :full-width-mobile="false"
      />
    </div>
  </div>
</template>

<script setup>
import { assetCDN } from '~/helper'
import {
  FAQ_CONTACT_HEADER,
  FAQ_CONTACT_SUBHEADER,
  FAQ_CONTACT_CTA,
} from '~/constant/customGroupTours'
import CGTButtons from '~/components/pages/LandingPage/components/CGTButtons.vue'

// eslint-disable-next-line no-undef

const ASSETS_CDN = assetCDN()

defineProps({
  title: {
    type: String,
    default: FAQ_CONTACT_HEADER,
  },
  content: {
    type: String,
    default: FAQ_CONTACT_SUBHEADER,
  },
})
</script>

<style lang="scss" scoped>
.image {
  background: linear-gradient(180deg, rgba($brand-green, 0.12) 0%, rgba($brand-green, 0.04) 100%); // v2 — was off-brand mint gradient
}
</style>
